import {
  DkimStatus,
  MailFromDomainStatus,
} from "@redotech/redo-model/email/domain-verification";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getCustomDomain = {
  name: "getCustomDomain" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    domain: z.string().nullish(),
    mailFromDomain: z.string().nullish(),
    mailFromDomainStatus: createEnum(MailFromDomainStatus).nullish(),
    fromName: z.string().nullish(),
    fromEmail: z.string().nullish(),
    dkimStatus: createEnum(DkimStatus).nullish(),
    warmingEnabled: z.boolean().nullish(),
  }),
};
